import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const DoDontRow = makeShortcode("DoDontRow");
const DoDont = makeShortcode("DoDont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`A dialog is a “conversation” between the system and the user. It is prompted when the sytem needs input from the user or to give the user urgent information concerning their current workflow. There are two types of dialogs, modal and modeless.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Overview</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Modal dialogs</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Modeless dialogs</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Designing with dialogs</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Related components and patterns</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Accessibility</AnchorLink>
      <AnchorLink mdxType="AnchorLink">References</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Overview`}</h2>
    <p>{`Dialogs work best when used for short tasks or to alert the user to task relevant information. Dialogs are useful in many scenarios; they are less disorientating than navigating a user to a new page for simple tasks or knowledge gathering. However, dialogs are disruptive and can be distracting to the user. Use them sparingly.`}</p>
    <p>{`A dialog is triggered by a user’s action, appears on top of the main page content, and is persistent until dismissed. The purpose of a dialog should be immediately apparent to the user, with a clear and obvious path to completion.`}</p>
    <h3>{`Anatomy of a dialog`}</h3>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70.65217391304347%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAACJElEQVQ4y52Ty29SQRTG+TuMunLhUk1c+aK4tImJRhoTVjSpO3VlKhURWpg7c3m2/lGWNQ83bSpeygXu5fJseMnnnIGrRVpjvMkvczI5880539zjEUKAcw5ByPh/oPN8cd6jAl0oNE1TMMb+GcoXSV1BWh4lFIsjxQTy+TwKhQLK5TJKpZJa3bhYLC5BebT/5fAQ6U8JsA9RJeoRqSTir7eRiTAcHR/BMAwY3w3UajVUq1VUKhV0u11MJhOMRqMlaM80TWRjGhJhV1D2rXEN2XQG305O0G634TiOWlutFmzbVjGJdjqdJfr9vrp4//MBNLHwUHApKNvO6CnU5W2URIeJ8XiM2WyG6XS6AlVHn2VZyGWz0KSfc0HZcuJtCKlIHKe1U1VRo9FQ1fV6PQwGgwuhi4fDIer1OnK53PxxlKCug32MIS0fhfxzW14VOcPg7BxybzgcwVwRJA9l/2k9CatpKbPdCih225tOxktMxiNpxw/YVvMCQfJQ+kAv6j4GVUmri9XqwnbO0erA6fRRMWp/CNIP+S6Cve0wgsEgAoEA/H7/gg1svHiOZy+38HDHwd0wcPs9cCc055aM7+30sKvtQ+dM/tg0KTQl4Rh2peCT9XX4fD54vd4Fa1h79AD3Hz/Fjc2vuL5l4+qmKanjmlyvBJu4+eoYUZZDMinH79fopeTo6PrSTK7Mq5A5lyLA3oTA42zu4d+EfsMvRZ2P7oFrHD8BwLRSsFE4EkUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "dialog anatomy",
            "title": "dialog anatomy",
            "src": "/static/06b9147db88c77f77ec28af059cf69b1/3cbba/dialog-4.png",
            "srcSet": ["/static/06b9147db88c77f77ec28af059cf69b1/7fc1e/dialog-4.png 288w", "/static/06b9147db88c77f77ec28af059cf69b1/a5df1/dialog-4.png 576w", "/static/06b9147db88c77f77ec28af059cf69b1/3cbba/dialog-4.png 1152w", "/static/06b9147db88c77f77ec28af059cf69b1/392b1/dialog-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Header:`}</strong>{` Includes a title, optional label, and the close icon. The title should be brief and clearly describe the dialogs’s task or purpose. Use the optional label above the title set the context for the information in the dialog.`}</li>
      <li parentName="ol"><strong parentName="li">{`Body:`}</strong>{` Contains the information and/or controls needed to complete the dialog’s task. It can include message text and components.`}</li>
      <li parentName="ol"><strong parentName="li">{`Actions:`}</strong>{` The main actions needed to complete or cancel the dialog task. `}<a parentName="li" {...{
          "href": "/patterns/dialog-pattern#buttons-groups"
        }}>{`Button groupings`}</a>{` change based on modal variant. Use descriptive words for the actions like Add, Delete, Save and avoid vague words like Done or OK.`}</li>
      <li parentName="ol"><strong parentName="li">{`x:`}</strong>{` The close `}<inlineCode parentName="li">{`x`}</inlineCode>{` icon will close the dialog without submitting any data.`}</li>
      <li parentName="ol"><strong parentName="li">{`Overlay:`}</strong>{` (Modal dialogs only) Screen overlay that obscures the on page content.`}</li>
    </ol>
    <h3>{`When to use a dialog`}</h3>
    <ul>
      <li parentName="ul">{`Use to focus the user’s attention.`}</li>
      <li parentName="ul">{`Use for short task completion.`}</li>
      <li parentName="ul">{`Use to gather input from the user.`}</li>
      <li parentName="ul">{`Use to display relevant information.`}</li>
    </ul>
    <h3>{`When not to use a dialog`}</h3>
    <ul>
      <li parentName="ul">{`Don’t use if the content is unrelated to the current workflow.`}</li>
      <li parentName="ul">{`Don’t use to display complex or large amounts of data.`}</li>
      <li parentName="ul">{`Don’t recreate a full app or page in a dialog.`}</li>
      <li parentName="ul">{`Don’t use when the user hasn’t triggered the dialog.`}</li>
    </ul>
    <h3>{`Dialog types`}</h3>
    <p>{`There are two types of dialogs, modal and modeless.`}</p>
    <p>{`A `}<em parentName="p">{`modal`}</em>{` dialog triggers a state (or mode) that focuses the user’s attention exclusively on one task or piece of relevant information. When a modal dialog is active, the content of the underneath page is obscured and inaccessible until the user completes the task or dismisses the modal.`}</p>
    <p>{`When a `}<em parentName="p">{`modeless`}</em>{` dialog is active the user can continue viewing and interacting with the main page while the dialog is open. Modeless dialogs are commonly used to present non-critical information or optional user tasks.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Usage`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Context`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Modal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use to present critical information or request required input needed to complete a workflow.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Focuses the users attention exclusively on one task or piece of information. On-page content is obscured from the user while the modal dialog is open.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Modeless`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use to present non-critical information or optional user tasks.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`On-page content can be accessed and interacted with while the dialog is still open.`}</td>
        </tr>
      </tbody>
    </table>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.38586956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABKUlEQVQY03WRv0/CQBiG+X+NiUYlhlQTi2CVzZmdOunkhPEHVRItbUUuwACpYXJpAa+0R6997R1BQeObPLe8lyffd5dDljRNJUmSrAEI0u+ec44gCP4QhTTr5kKFnDgcx4GiKFBVVXKkFlE8LmFzqwDL6WAZ13VRrVah6zpqNcGF5Oy8hjYZ/ghN05SiTodgOBhg9N5Hl9jI7x/Atl/lRTFxHMeglGI8HmM+Z0hjChZO4E0iRIyvT1ipVGBZrWyiNzz3AaMdoHyigZDFhGJdkdksxNOjgftGE/WXKe7sIJNz+TzZqyyEhBBomoZ8fhc7ewVsHF5iW71CqXyKXq/7SziD0XjAza2B6yZFvcUQRjyTrQgZY/B9X65D6SeC6YfE8zzZrX7cf1l2X8uqryfbJBOCAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "dialog examples",
            "title": "dialog examples",
            "src": "/static/ae6e1a013d67a4dc66df1b537f9c9db1/3cbba/dialog-1.png",
            "srcSet": ["/static/ae6e1a013d67a4dc66df1b537f9c9db1/7fc1e/dialog-1.png 288w", "/static/ae6e1a013d67a4dc66df1b537f9c9db1/a5df1/dialog-1.png 576w", "/static/ae6e1a013d67a4dc66df1b537f9c9db1/3cbba/dialog-1.png 1152w", "/static/ae6e1a013d67a4dc66df1b537f9c9db1/392b1/dialog-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">Modal dialog (left) and modeless dialog (right)</Caption>
    <h3>{`Best practices`}</h3>
    <h4>{`Use dialogs sparingly`}</h4>
    <p>{`Don’t overuse dialogs. They are disruptive and can easily annoy the user if used incorrectly or too frequently. When dialogs are used for non-workflow related tasks, it is likely a user will start ignoring or dismissing the dialogs without fully understanding the content. This can cause users to make hurried or impulsive choices when dealing with more critical dialogs.`}</p>
    <h4>{`Dialogs should be user initiated`}</h4>
    <p>{`A user action, such as clicking a button, should trigger the dialog to open. Don’t interrupt the user by opening a dialog when they aren’t expecting it. Avoid system generated pop-ups that distract the user while working, such as Net Promoter Score. Triggers can either be a direct or indirect consequence of a user’s action. An example of an indirect action is a user closing a tab with unsaved content that then causes a dialog to ask if they want to save their changes before closing. If the system is autogenerating an alert that is not a consequence of a user’s action, but a response to processes happening in the background, then a toast notification should be used instead.`}</p>
    <h4>{`Keep dialog tasks simple and focused`}</h4>
    <p>{`Dialog tasks should be direct and easy to complete. Avoid feature creep in dialogs where a once simple dialog has become bloated with interactions. When deciding to use a dialog consider how the task could expanded in the future and if a dialog will be able to effectively incorporate additions. An example of a simple task would adding a new item to a list where the item details are added and submitted via a dialog.`}</p>
    <h2>{`Modal dialogs`}</h2>
    <p>{`Use a modal dialog to present critical information or request user input needed to complete a user’s workflow. Modal dialogs are disruptive and should be used sparingly. When active, a user is blocked from the on-page content and cannot return to their previous workflow until the modal task is completed or the user dismisses the modal. Any information or input requested should be directly related to the user’s task at hand.`}</p>
    <p>{`Modal dialogs are commonly used for short and non-frequent tasks, such as editing or management tasks. If a user needs to repeatedly perform a task, consider making the task do-able from the main page. A modal dialog adds to a workflow’s interaction cost; it takes the user out of their previous context and requires additional actions to complete and dismiss. When considering, ask is this critical to their current workflow?`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.05434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB3ElEQVQoz62TW4/SUBDH93PBCwG+huDbbkz0QfFFH6BQrm2WEu6XhGBiQsInMDGuLbAtpb5s8COshMQAQg13/jITXcFd37bJ9EzP/OeXmek5Z/v9Ho/1EOuMnO12i1arhXw+j1KphGKxeLcWCgVeHzLS5HI5NJtNrNdrhjJwuVzC5/PB6XTC7XbD5XKxeTweeL1eXv/4x3HyHQ4H/H4/FovFX+Bms0G9Xocsy1AUBZlMBqlUClfqZ9x+u8VwOMRoNMJ4PEa32+UY6cgop9FonFZIH1R+NBpFMpnkhLAQxgftI2Y/57DnNmzbxm63g2maEASBdWSiKKJcLmO1Wp0CaTMejzNMkiSEw2Hous5Cgk0mE0ynUxiGgUgkcqeLxWKoVqsPAyl4DKRkis1mc/yY2VhvduiZ/UNMYB0ZdVWpVO4D/205GAxiMBgcHYotv7/efEEodAD+1v0XSJuJRIKHTBWSOJ1WkL6UISslvH33Ha/fA8GKBSkpIiXJrKWcWq12H5jNZrkqGjK1S3MKBAK4OD/HxbPnePoyiyevqnjxRoEYCUE4aEhLOXR+T4B0sPv9PjRNQ6fTQbvdZp9+Sq9nomfoMK+vYOmfYHRVaIc4aUirqiosy2IGAx/76v0CSigBpwVK2pMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "modal dialog example",
            "title": "modal dialog example",
            "src": "/static/331d87e197c0e40597e7b10edda86707/3cbba/dialog-2.png",
            "srcSet": ["/static/331d87e197c0e40597e7b10edda86707/7fc1e/dialog-2.png 288w", "/static/331d87e197c0e40597e7b10edda86707/a5df1/dialog-2.png 576w", "/static/331d87e197c0e40597e7b10edda86707/3cbba/dialog-2.png 1152w", "/static/331d87e197c0e40597e7b10edda86707/392b1/dialog-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`When to use`}</h3>
    <h4>{`An immediate response is required from the user`}</h4>
    <p>{`Use a dialog to request information that is preventing the system from continuing a user-initiated process.`}</p>
    <h4>{`Notify the user of urgent information`}</h4>
    <p>{`Use a modal dialog to notify the user of urgent information concerning their current work. Commonly used to report system errors or convey a consequence of a user’s action.`}</p>
    <h4>{`Confirm a user decision`}</h4>
    <p>{`Use a modal dialog to confirm user decisions. Clearly describe the action being confirmed and explain any potential consequences that it may cause. Both the title and the button should reflect the action that will occur. If the action is destructive or irreversible then use a transactional danger modal.`}</p>
    <h3>{`When not to use`}</h3>
    <h4>{`Modals prevent access to the main page`}</h4>
    <p>{`Don’t use if additional information outside the modal needs to be consulted. While a modal dialog is active a user cannot interact with the main page and is restricted to only the information in the modal for making decisions. Modal tasks should be easy to complete with the limited information presented in the dialog itself. If a user needs access to additional information then consider using a full page instead.`}</p>
    <h4>{`Don’t nest modals`}</h4>
    <p>{`One modal should never trigger another modal. If the first modal task is dependent on a confirmation modal to approve then that first task should not be preformed in a modal.`}</p>
    <h4>{`Don’t make modals full page`}</h4>
    <p>{`If a modal dialog needs more space than the large modal component allows then the content should be displayed on a page of its own and not in a modal. A modal is not an alternative to page.`}</p>
    <h3>{`Modal variants`}</h3>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.90760869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACRUlEQVQ4y41TW28SQRjtv/QHGB+M8cGofTECghQe5FKWQAMkBNjlUkEockkQU6I1AbQ2hgSWOyyBlhATbbiGy3FnqFwqSf2SLzM7+82ZM985swcxFosFbgdZ28xda7tq9gRBAMuy4DgODocDdrsdLpcLTqcT6XR6BTSZTBAOh+k/UsuyYnJu8ZtFMBjEaDRaAvI8D4VCAaPRCL/fj0QiAY/HA6lUilgstmJMNjAMg1AohFKphEqpgFaDRywSgk6nw2AwWAKWy2WoVCp6ai6XQ6fTQSaTgVwup+B/Yzwew2w2I5n8iKvLNqrtazR/A/HT7zAyBgyHwyVgsVikgBqNBgaDgaZer4dSqUQ8Hl8Bkg02mw3Pnu/j0cMHuP+Uwb0XKTyWOmA5MqLfv2HY7/dRq9VQr9fpWK1WV/Ner7fq4Xw+R6vVQrPZRLvdQadVxZWQF69dgiC0MJvNloC4IwgQyV1O2FVLGZI+VioV2myeL4pjma51u90VQ8KAsCuKIvKFAgpi5vN5EFEbjQam0+laZSKAWq2GVquF2cTgUK+FRCJBJBLZUpk4wWQ6wttACIF3QZychGGxWv9VmYARq5C+NS6vkfpyDuVrhajyhw2VJ1Tlb+cXW9f8cfGV2mk0Gq4ZymQyWnx29hn7TAZPDgJQvHopMoxu2cZweIhwNIHez184Tcahc3zCgSUFRv8G/cENIFHO6/XC5/NRL3o9HI6PvXC73chms1svJRqNUvOTgzjWBcbCweoMIfI+vH4pdym3+U7/p/YP5pOK0WRmOB8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "modal dialog variants",
            "title": "modal dialog variants",
            "src": "/static/cc44493583540b98da806670d5b67b61/3cbba/dialog-3.png",
            "srcSet": ["/static/cc44493583540b98da806670d5b67b61/7fc1e/dialog-3.png 288w", "/static/cc44493583540b98da806670d5b67b61/a5df1/dialog-3.png 576w", "/static/cc44493583540b98da806670d5b67b61/3cbba/dialog-3.png 1152w", "/static/cc44493583540b98da806670d5b67b61/392b1/dialog-3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variant`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Usage`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/modal/usage#passive-modal"
            }}>{`Passive`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Presents information the user needs to be aware of concerning their current workflow. Contains no actions for the user to take.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/modal/usage#transactional-modal"
            }}>{`Transactional`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Requires an action to be taken in order for the modal to be completed and closed. Contains a cancel and primary action buttons.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/modal/usage#acknowledgment-modal"
            }}>{`Acknowledgment`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`System requires an acknowledgement of the information from the user. Contains only a single button, commonly “OK.”`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/modal/usage/#progress-modal"
            }}>{`Progress`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Requires several steps to be completed before it can be closed. Contains a cancel, previous and next/completion buttons.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Dismissing variant modals`}</h3>
    <p>{`For passive modals:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`x`}</strong>{`: Clicking the close `}<inlineCode parentName="li">{`x`}</inlineCode>{` icon in the upper right will close the modal without submitting any data and return the user to its previous context.`}</li>
      <li parentName="ul"><strong parentName="li">{`Click elsewhere`}</strong>{`: Clicking outside the passive modal area will automatically close the modal.`}</li>
      <li parentName="ul"><strong parentName="li">{`Esc`}</strong>{`: Press `}<inlineCode parentName="li">{`ESC`}</inlineCode>{` on the keyboard`}</li>
    </ul>
    <p>{`For transactional, progress, and acknowledgement modals:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Task completion`}</strong>{`: clicking the primary action will complete the task and automatically close the modal.`}</li>
      <li parentName="ul"><strong parentName="li">{`Cancel button`}</strong>{`: clicking the cancel button will close the modal and return the user to its previous context. Cancel undoes all applied changes.`}</li>
      <li parentName="ul"><strong parentName="li">{`x`}</strong>{`: Clicking the close `}<inlineCode parentName="li">{`x`}</inlineCode>{` icon in the upper right will close the modal without submitting any data and return the user to its previous context.`}</li>
      <li parentName="ul"><strong parentName="li">{`Esc`}</strong>{`: Press `}<inlineCode parentName="li">{`ESC`}</inlineCode>{` on the keyboard`}</li>
    </ul>
    <h2>{`Modeless dialogs`}</h2>
    <p>{`Use modeless dialogs to display non-critical information or optional tasks related to the user’s current workflow, like “find and replace.” A user still has access to the on-page content while the modeless dialog is open and a response is not required to continue working. However, a modeless dialog does require an action from the user to be dismissed.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.05434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABkElEQVQoz61TTU/CQBDtf+RYCBDPHoyJxqB41BAD0aMHPTSevfIXCB8h8WDCgYTUBkKhH5a220L73FlcUmLFi5O8dPpm5u3szq4Cbmma4j+MdBQppus6ut0uBoMB+v2+APkSkstDr9eD53lCR9lsNsLRNA2FQgGVSgXlclmgWCxCVVWUSiVUq1URk3HpEyg+Go22grLDMAxhmiYWi4VYzXVdGIaB2WwG27bhuJzzfKx8BvdzBd/3EQTBDrKxnWAURViv1+I7nU5F0r5FHMQxWh5xHCHm+SREdYSdIIEIy7IwHo/R6XTQbrdRr9dRq13h8uIUx/dvOHoE1AeGMy2Cz5LtIDjiOP4pSCRtdT6fi+0Ph0M0Gg00my207m5w/fSO85cEJ88+bl9DhFH6LYfDHU4mEzFxwnK5FJzFz9A2dYSugcD54C05yF63XMFshyREg5AQopYDP+BbDRhCFu/d3YOCNGUSIF8OimLkS9C/rEPeGZIlSSJIxpgooq9MyntJUpBAtTJH+evpZQuzXf2W+wV5QXb0O5DRjgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "modeless example",
            "title": "modeless example",
            "src": "/static/eae4923ce32710a71ed06925038f1a68/3cbba/dialog-modeless.png",
            "srcSet": ["/static/eae4923ce32710a71ed06925038f1a68/7fc1e/dialog-modeless.png 288w", "/static/eae4923ce32710a71ed06925038f1a68/a5df1/dialog-modeless.png 576w", "/static/eae4923ce32710a71ed06925038f1a68/3cbba/dialog-modeless.png 1152w", "/static/eae4923ce32710a71ed06925038f1a68/392b1/dialog-modeless.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <h3>{`When to use`}</h3>
    <h4>{`When access to the page is needed`}</h4>
    <p>{`Use when a user needs to compare or refer to information in the main page alongside the modal. users can interact with the modeless content and the on-page content simultaneously.`}</p>
    <p>{`A modeless dialog window can be moved from its original placement on the screen. This allows the user to access information that might otherwise be hidden by the dialog.`}</p>
    <h4>{`Aid or accelerate a user’s work flow`}</h4>
    <p>{`Use to perform tasks or present informational along side the main page content that can accelerate or aid a user’s workflow. For example, a “find and replace” dialog can help a user perform and automate edits quicker. The user can chose to automate the changes or navigate through the page by using the “find” feature and manually make updates.`}</p>
    <h4>{`Display additional information`}</h4>
    <p>{`Use to display additional information that can help inform a user’s decision or workflow. For example, use for incontext help or tutorials such as a knowledge center.`}</p>
    <h3>{`When not to use`}</h3>
    <h4>{`Don’t use if the user’s response is required`}</h4>
    <p>{`Use for optional or non-critical tasks only. If a user’s response or input is required to progress the workflow, use a modal dialog.`}</p>
    <h3>{`Modeless variants`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Passive`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Presents additional information concerning the user’s current workflow. Contains no actions for the user to take.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Transactional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Presents the user with optional action/s. Actions can be repeated without closing the dialog. Contains at least one button.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Dismissing modeless dialogs`}</h3>
    <p>{`There are several possible ways to exit a modeless dialog.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`x`}</strong>{`: Clicking the close `}<inlineCode parentName="li">{`x`}</inlineCode>{` icon in the upper right will close the modal without submitting any data.`}</li>
      <li parentName="ul"><strong parentName="li">{`Cancel button`}</strong>{`: If a cancel button is used then clicking it will close the modal. Cancel undoes all applied changes.`}</li>
      <li parentName="ul"><strong parentName="li">{`Esc`}</strong>{`: Press `}<inlineCode parentName="li">{`ESC`}</inlineCode>{` on the keyboard`}</li>
    </ul>
    <h2>{`Designing with dialogs`}</h2>
    <h3>{`Button groups`}</h3>
    <p>{`When placing buttons, Cancel is always the outmost left button option and the primary action is always the outmost right button. There should only ever be one primary action per dialog. Dialog buttons are always full bleed and attached to the bottom of a dialog.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.822252374491185%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACBklEQVQ4y42TT2/TMBjG8/ngM2zaBWmHHVEryrSq0i4TFw4g+gV64gjjRiu1SFM7VZoqWg0hlWZrQv8lwJo/jmP7wa+zNumEACuv7Dj2z+/r54mllMLfGn3/15riWosGUkowxiCEgNSTPBVI9bgIpG/T6RTL5RJhGCKKop0gBjUDDIIAvV4Po9EIi9kNktCHTGOoB8D5fI7FYoH1em2gQRjpPtL7Q4giMI5j2LaN8fgbPvZu0Lz6hetbtpNhsWzzLhJARNtQqgBM0xRJwhAzjpO3wKMzhZcfMoAQ2ULXdVEul1F5fozjZ09xdNbE/hvg4DXD/iuOqady4G4Wm6B5bDOjErvdrr6aS1x2L/DpykVzBLSGCs3P+tqygmBtNmyAUmZRPETcC/QHXXeC9lmkDpVMm4oQmqfI5yQCEkMLyHmir4iDJel9cAMzGZJig8EAw+HQ2MJxHBOe5xn18ywlvoxdXI9nmDg/8X3uwVuttI1W8PwfucrkIQL4vq9PTfTp3GT80NgE5FzoXiHh6dZ32sX6SaA2QIKQqSnDVquFTqeDdrttxv1+fwuVUoDFkV4bm4OpAtueYOLe4aujGTy7Z4syomg0GiiVSqjVaqhWq6hUKqjX6wWgLvk2xGx1BylSvHt/jsMnB9g77ePxC8Beitw2//svS5VZKfOnMJUxLhFzmF+WlP4NuuzZ9voU/ZcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "button grouping examples",
            "title": "button grouping examples",
            "src": "/static/2647454376e20ebe425ce7c747dfb284/3cbba/dialog-5.png",
            "srcSet": ["/static/2647454376e20ebe425ce7c747dfb284/7fc1e/dialog-5.png 288w", "/static/2647454376e20ebe425ce7c747dfb284/a5df1/dialog-5.png 576w", "/static/2647454376e20ebe425ce7c747dfb284/3cbba/dialog-5.png 1152w", "/static/2647454376e20ebe425ce7c747dfb284/8c77b/dialog-5.png 1474w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">
  Button groups: one button, two buttons, three buttons, and progress buttons.
    </Caption>
    <h4>{`One button`}</h4>
    <p>{`Single buttons are placed on the right side, span 50% of the dialog, and bleed to the edge. The single button format is most commonly used for acknowledgment dialogs. In most scenarios, a primary button is used when only one button is needed.`}</p>
    <h4>{`Two buttons`}</h4>
    <p>{`When using two buttons, the secondary button is on the left and the primary button is placed on the right. Each button spans 50% of the dialog and are full bleed to the edge.`}</p>
    <h4>{`Three buttons`}</h4>
    <p>{`When three buttons are needed, each is 25% of the dialog width and aligned to the right side of the dialog. Only the outmost right button is allowed to be a primary button with the other two being secondary buttons. If all three actions have the same weight then all three should be secondary buttons.`}</p>
    <h4>{`Progress indicator buttons`}</h4>
    <p>{`The three progress indicator buttons are: Cancel, Previous, Next. Each button’s width is 25% of the dialog window and are full bleed. Previous and Next should be grouped together and placed on the right half of the dialog, with Previous as a secondary button and Next as a primary button. The Cancel button is aligned to left side of the dialog and uses a ghost button.`}</p>
    <p>{`In the last step of the sequence, the Next button label should change to reflect the final action.`}</p>
    <h3>{`Behaviors`}</h3>
    <h4>{`Trigger`}</h4>
    <p>{`Dialogs are triggered as a result of a user’s action and are not system generated. Common components that can trigger a dialog include, button, link, or icon.`}</p>
    <h4>{`Focus`}</h4>
    <p>{`Once the dialog is open, set the initial focus to the first location that accepts user input. Focus should then remain trapped in the dialog until it is closed.`}</p>
    <h4>{`Scrolling`}</h4>
    <p>{`The modal component has four set sizes and each size has a set max-height. If the dialog content is longer than the dialog height then the body section should scroll vertically with the header and footer remaining fixed in place.`}</p>
    <h4>{`Validation`}</h4>
    <p>{`Validate a user’s entries before the dialog is closed. If any entry is invalid then the dialog should remain open with the entry marked with an error state and include an inline error message. The message should inform the user what has happened and provide guidance on next steps or possible resolutions. Effective and immediate error messaging can help the user to understand the problem and how to fix it.`}</p>
    <p>{`When possible, we recommend validating the user’s data before submission. This type of inline validation (aka `}<a parentName="p" {...{
        "href": "/patterns/forms-pattern#errors-and-validation"
      }}>{`client-side validation`}</a>{`) should happen as soon as the field loses focus. This will help easily identify the elements that need to be corrected. On field error messages should disappear when the form criteria is met. If the data was not able to be submitted due to server-side issues then an inline notification should appear.`}</p>
    <p>{`Decrease the chances of invalid data by using selection controls and bound entry controls components that provide users with specific input choices, for example radio buttons and dropdowns.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "99.04891304347827%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACn0lEQVQ4y4WUy44SURCG2Zvo0HcWRghNX7gLARqmoQeQkFnMzoyiMwlgGHBhwlP6AroZTVy4URPf4bfqDM2cVhgXX+rc+q86VXU6pWkaGF3XE/Caqqr/JT4X66TigabptKFBoU1FUROHHkIW3gtyRIZhoFAooFQqoVgsinE2m0Uul9vDcxles21bfBuLpmRP5XIZ3W4XnU4HtWoVvu+jSPg7eMwO+RyPHceB53kwTfNecJ8vokoiYb+PgETZ9pnBQIzj9Xq9jkajgXKlAptuwViWdZd7ijQl56PkF1Ej7z55LrqesL7rknWF9Wju0BWdvA2XrEtzTo1FEQoNEk3FoabJdsnrJOgiarVw1mrjrN3GUGIk6AgiGl/Q2YtGE6qh766sSjkkGhTVqP4cUa0uCKs1NMnJMdqUohblNFGUeMA54AT7BFfO2V3HfoA8Q2cTRZGrXCGvLyYTjEYjUeljBDvboyI1qUAH24bhqLjSDLeFiFhqm0O4VCzTjAX1e0FFUdCmRJ+fn2Oyi7LX64m+PAbvB0EA0zCFmKFLbZNOp8XmdDrFcDjEeDwWfXh6enqUMAwRRRG1jbWvQ0KQ88IHOVKRK3IQRxP8TcDrPXI6OJzD+Mp8VY5sQC9EJhr0iTDBWUTn+uFhQS49twkX4l98FLwK8m4VNlHwyHo761boWyspyBP2slgssN1usV6vsdlsyG7wfnODdzcf4Cw/4enqNzLzH0i//QnliuzVLyhvvkPNdqGePKLHIeUwk8lgNpthtVphPp8L8cViieVijuv5Cs9mH5F+/Q3Kq1ucXH4hbvHk8itOXn6GlgtgqI/p52DevRSuDv8x+NocaYw8Nw1Ki67CIpsxNaosYah3WKYIiDX2gvzxYSwJU/xZrAPrMX8A4DlNZIs5/24AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Invalid example",
            "title": "Invalid example",
            "src": "/static/74d3a153acbfa927b9b93b55067f7dcb/3cbba/dialog-validate.png",
            "srcSet": ["/static/74d3a153acbfa927b9b93b55067f7dcb/7fc1e/dialog-validate.png 288w", "/static/74d3a153acbfa927b9b93b55067f7dcb/a5df1/dialog-validate.png 576w", "/static/74d3a153acbfa927b9b93b55067f7dcb/3cbba/dialog-validate.png 1152w", "/static/74d3a153acbfa927b9b93b55067f7dcb/392b1/dialog-validate.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">
  Real-time validation. The user has left the first required field empty.{' '}
    </Caption>
    <h4>{`Task completion and loading`}</h4>
    <p>{`The task completion action should take place immediately. If a short loading period is needed then a loading spinner and overlay should appear on top of the modal body area with content disabled. The primary action button should be disabled while loading is in progress.`}</p>
    <p>{`If the action requires more than a few seconds to complete, display progress information elsewhere on the screen to inform the user how long it will take to complete.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "99.04891304347827%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAByElEQVQ4y41Uy5KCMBDkG+SpVWpZPERgUQ4exHJvelLLD/Fi6dlfn6UTB5OAtR66hgyh6emZxHIchwDXdTVw/lvYti2i9U66TVK+AAaDwddgMkSLyTzPp/F4TNPplCbAZCLW3wAVaQp5Eccx5XlGWZZRmqaUJEkH8/lcQM35vv8mZL8QoyiixWIhyBBNIK8SYj8QBIH03vPeHiIRhqFQiU1qZDCBCShk6yxuAhJRFLdKVDUS5vqt1GuUSQ5bV4i/wb9uiY13SfQFoSMVqoTYoJcZUpJVNC9rig0L2AatKepw4mWe522XZXNSWlZrWq5/xTPnuXFQqSlUCdEULoP/jnVZlvRT5G1nuwqZ0P2sUB0X4ddLEatHjmdVdrk5HK6nD7bZFCYwYf4s8IO2D52TYn7wH3o9xALss9ns4wD3HUP2upcQPhRFQavVqhesRu0ye9kZGya8Xq/0fD7pfr/T4/Fo4+12o/1+T7vdTqCua4HtdkubzYZGo5G4xrSxwQE/HA50uVzodDoJnM9ngePxSFVViQlAFSqQGw6HwjKUbrF/IFRvX/XS5D34AEA1/AzgW5AitoTYhISEb6zlZpFrMMTz653/yjP+ADmvKpAzUTXQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "loading example",
            "title": "loading example",
            "src": "/static/845f419686d87ef19782384b8b0f60ea/3cbba/dialog-loading.png",
            "srcSet": ["/static/845f419686d87ef19782384b8b0f60ea/7fc1e/dialog-loading.png 288w", "/static/845f419686d87ef19782384b8b0f60ea/a5df1/dialog-loading.png 576w", "/static/845f419686d87ef19782384b8b0f60ea/3cbba/dialog-loading.png 1152w", "/static/845f419686d87ef19782384b8b0f60ea/392b1/dialog-loading.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Using components`}</h3>
    <p>{`Appropriate components to use in a dialog include form inputs and controls that aid in collecting information from the user. Other components like content switcher and structured list can be used to organize information. When possible, avoid using complex components that can complicate task completion or prolong a user’s time in the modal. A user’s journey through the modal should be direct and short.`}</p>
    <h4>{`Avoid components the will direct the user away from the dialog`}</h4>
    <p>{`Avoid components like links that will take the user away from the current context and the task at hand. A dialog’s purpose is to focus the user’s attention on a particular task and should not encourage any action that is not related to that task’s completion.`}</p>
    <h4>{`Avoid components that hide information`}</h4>
    <p>{`When possible avoid components that hide information or choices from the user—like accordion and tabs—and require additional effort from the user to discover all the available content. Time spent in a modal should be minimal and only information needed to complete the task should be included. If there is too much information for a user to consume in a dialog context, consider using a full page instead.`}</p>
    <h4>{`Avoid complex interactions with data tables`}</h4>
    <p>{`When possible avoid using a data table in a dialog as it is a complex component with its own workflow and decision making that can overly complicate a user’s choice and task completion in relation to the dialog. If a data table is necessary then the tables should be kept as simple as possible with limited interactions. For example, you can use data table to make selections that will be incurred by the dialogs action but avoid preforming table functions like batch editing or batch actions inside the modal itself. For smaller sets of data or selections consider using a structured list, dropdown, or tile set instead.`}</p>
    <DoDontRow mdxType="DoDontRow">
      <DoDont colMd={6} colLg={6} caption="Do: keep data table interaction simple." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.47282608695653%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAADOElEQVQ4y32Ty08TURTGuzAaIPFRqUUNERKjwYUrg/+AKxPcEhducePCjWIjQsOCha4IMa4IK5mkBISqFJSdrYGkPhL64N0XpY8pbWemM/Qx9x7PuTwaILHJl3PmTu/vfuecuRaLxfJqZGTk65/fv9I+rzfy0+eNBgLL0XA4FF0JB1FhkYdDQaFQKCQUxnWKgUAgsrm5mRodHfUQC2V56f48uwj4y+U1UPUqGGUGRoWDojPxrBk12MNnWitXGVSrFSiXy1Cr1aBSqdBWWFhY8CPrhQBOTX/2Vk2ArLxbUzWDKZrOikqJJdIaS2VyLJ3NMUXFNVShqDJZllkmk2H5fJ6pqlojoMfjWSSWAE5MTPh0vQTxeMxMJrcpws5OEuRsBmQ5C8ViAbLZLORkGQqFPKpwKJ7L5Uxy63a7l46AH8fHfel0GiKRiBmLxSAYDEIqlYKtrS3Y2NhAqCzy7e1tAUZ3h+K4z6Syp6en68CpqSkf5xxKpZKJJYg/a5qGzooiGoYBiqKArusnxfG9SSXPz8/XgTghHzlCmfF4HFZWVoCcRqNR4Yoc4iTF2kmHtOeUw7GxMR/2Ash+IpGAtbU17OEOEDyZTArIYckEovYcSACph8eAw8PDvvX1dXJgrq6ugt/vFy5J1EM6ZHl5GegdHULOyS2KU9+pNS6Xa+nYlKvVKvXMpPLIFfWSnOGnIXKqgPp4QhwnLXo4Ozt7Gogbzd3dXVEafRYEoUgDoFIppyHRAapKUeNFRTH3v8O5OnBychKnzAQQHXF0xnHinHJyQTmC+N7eXl1GiZcNjRulfeD3b546cGZmxkuLuLmGUIaRIYRuAUOQiNgGhs4PlGDxVIHF0jqL7Ki1ggHg+jRXvynuLx5xl2n8jDEUF9E0xeFAbejp6YGuri7UI+h6+AA6n/2FW70AN58D3H4N0Pb4h//yWbzLTU1Nb7q7u98PDQ1N9Pf3S06nUxoYGDiKg4ODUm9vr9TR0SG1trZKbe3tUvuN69LFu0+lhs63UtO9Qanx/jvX+TtPPtitjX0Wu93ubGho6EOnjv/JarU6bDabo7m5GWVztFw647h2weK4iqLYYj3XZ7tid/4DiQ/AxJz+lncAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Do: keep data table interaction simple.",
            "title": "Do: keep data table interaction simple.",
            "src": "/static/f7cc19c54a9b9a38e0de88f2403471c7/3cbba/dialog-table-do.png",
            "srcSet": ["/static/f7cc19c54a9b9a38e0de88f2403471c7/7fc1e/dialog-table-do.png 288w", "/static/f7cc19c54a9b9a38e0de88f2403471c7/a5df1/dialog-table-do.png 576w", "/static/f7cc19c54a9b9a38e0de88f2403471c7/3cbba/dialog-table-do.png 1152w", "/static/f7cc19c54a9b9a38e0de88f2403471c7/392b1/dialog-table-do.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </DoDont>
      <DoDont colMd={6} colLg={6} type="dont" caption="Don’t include complex interactions in data tables that are not necessary to complete the task at hand." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.47282608695653%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAADgElEQVQ4y32Tz28bRRTH94Co0kgUTIwLKKKRECgcOKH2H+CEFC5IRD30glBaIUCRoCQWIbFyyKGcoqi0grpBatVtHfKrauK0IDjglVrJikCmdhzb2V3/XNuJ7f3pXzvzeDNJsaASK333ff1m5jNv3noEQRAmFxYWNra3t7VIJCJLkqTEYjElHo8riQRTQkmgj8cfH4n5BNdj9LHYX3I6kyldCwbDjIUSvtrY2HwI+DR0E5xmBzpdgqJgtwj+bkOz1ct1XQLUbYPbbQElXSDo2fPbr79EkXWRA2/cuRfRdICkWutmyw5hUko2ickm2ZH3SVI54DlVs4lSNElKrZKkXCZyvk5yZbNrtAB+Wtt6yFjCMXx98OVdafI2wPi1ujv2nQ4fLdTgwlUTzl9pwMeX6/DJ9zaPbOzCVQs+D9rwxY82jF+36Gc/GO5FEeDDya1HjHVY4c1bUqFUhvSe4mbkLPwZi0OuoEEyJUMimYaiVuVeVvNQKFWAzS2i0NN8QXNtbNPK6voj4QlwdWVFwoaAbVuuaehQrZTBtkww9AaPzaYDBuabjs3l9ERx3GU9fHD/fg8YDAalUqkEKDebzcLOzg4oqgqKokA+n4dqtQqZTIbnKpUKaOUylA9F2Zp2uw1ra2s94OLiorS/vw+aprm5XA52d3ehWCwCgxcKBQ7Z29vjcAbCeU/Ega1W69/A+fl5KZVKgaqqbjKZhGg0yqtkSqfTwDbB/yawMbYJqxznMlFZlt1GowGhUKgHXFpakjqdDuCAy47HqjIMg1dWq9W4ZyfQdf2/ovV6nfdwc3PzaSAudA8ODvjRcCKHsGjbNj8q86Zp8g0Mg0WTNnSdA8PhrR5weXlZoviVGRArolgZtSyLMs+qYB5BtNls9uRYtOWY1LEOgT8/CPeA6+vrEZbExV2EEowEIYR5BPGIbSBY+ZFyJFuq85sjF41u3QEIrR7dFPa6ey/M7zL7/IQQFOXRdfnmwNowNjYGIyMjqPdh5L134fSnf8AbEwCvjwO8+TXAqbO/R198Fu9yf3//N6Ojo5fn5uaWpqenxUAgIM7MzPwTZ2dnxYmJCXF4eFgcHBwUTw0NiUOvvSo+//Z5se/0JbH/nVnx+JlvQ8+9de6Kz3N8SvD5fIG+vr4prNT/f/J4PH6v1+sfGBhAef0nX3jG/8oJwf8yisWTnmNT3pd8gb8BqGCxdyqi/psAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Don’t include complex interactions in data tables that are not necessary to complete the task at hand.",
            "title": "Don’t include complex interactions in data tables that are not necessary to complete the task at hand.",
            "src": "/static/db8fb0afd6cdfed28e5cea6f41fed3f3/3cbba/dialog-table-dont.png",
            "srcSet": ["/static/db8fb0afd6cdfed28e5cea6f41fed3f3/7fc1e/dialog-table-dont.png 288w", "/static/db8fb0afd6cdfed28e5cea6f41fed3f3/a5df1/dialog-table-dont.png 576w", "/static/db8fb0afd6cdfed28e5cea6f41fed3f3/3cbba/dialog-table-dont.png 1152w", "/static/db8fb0afd6cdfed28e5cea6f41fed3f3/392b1/dialog-table-dont.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </DoDont>
    </DoDontRow>
    <h2>{`Accessibility`}</h2>
    <h3>{`Focus`}</h3>
    <ol>
      <li parentName="ol">{`Shift the focus into the dialog when triggered.`}</li>
      <li parentName="ol">{`After the dialog opens, initial focus should be set on the first focusable element in the modal.`}</li>
      <li parentName="ol">{`For modal dialogs, the focus should be trapped inside the dialog and must not move outside the modal until it is closed.`}</li>
      <li parentName="ol">{`After a modal dialog closes, focus should return to the element that invoked the modal.`}</li>
    </ol>
    <p>{`Reference `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/UNDERSTANDING-WCAG20/navigation-mechanisms-focus-order.html"
      }}>{`WCAG 2.4.3 Focus order success criterion`}</a>{` for additional guidelines.`}</p>
    <DoDontRow mdxType="DoDontRow">
      <DoDont colMd={6} colLg={6} caption="Do: after the dialog is opened, set focus to first focusable element." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1088px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "91.91176470588235%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAACpklEQVQ4y62UTWsTQRjHZw+erLaIN70KnpUkmwTbiyiF4jeQvqg3P4RXP4YXjYogaL2pBA+2IjTRQ2vRvsW0zb7N7uz7zs4+PjObVqsRhPrAL/9MNvvj2XmGJQQLAMhx6384RpdhGJpMz/Pumab5EXlj2XYbs21jWpbVppS2/SBo+76PBEP8dhAEb13X+8AYuy8d+D+NbG1uKqHjOM/DMICd7S0Y7O9Dv/8ddvt96PV2gFIHyiqOUIhc/YrNvJYOUzb3tbdx0OFDl0Vgu0FKvTCXOG6gsKk/Eov6aZIJwE5fSAfzA41AH5Rwa489YTGA4UTcoDGYNAHTTcBmGTg+/xPGgfo8DznArhkuSsezZXTBHn7cICe+7flPI7yIIhQmIBnYMd6cAw3ESNxQKGHPiJTwwTt0bfS3VYfMY6045TAwbG6YDuwPLLAcF6jng+MyxB9FnuUF4ICUkLpMI8z1SiFjLbnRnudy5nnguhTkkLIshTRN/oaaShiWj5znXJMHUgmjKGoNR8nh30sJ8d7F4eHWSFEUxxbGcfxTmGWZEuLolZCXBb+T8fwPOC8PIh4XJUySVCNpmiohipUQ1zxJ5P7g3mEmw8xiBjz2MI+AQgE8YaUwcDSysrKihJ1Op7W+vg6YWbfbLQ7pdIpO93OxtMqK96tRsbx2BP5pB2BprdzD5S+RRqanp5Ww0Wg8npmZgampqbxSqUCtVoNqTQe9ehku6Vfh3C0Lzt8FODkrYGyuOCA/dQdkvpKOsTmhkWazqYT1ev3R5OQkoDjVdV3gWuj1hqjrFVFpXhNnZ00xcRvE+LwQ4wuHZOMoxHwpHZgaqVarZCi8gN+bKKuhVMc1+hp6o17Va1eu62dumvrYPOgTCzkifqWJXJQOzPIVho937Nfg6aHsB9w+fXV+xSfyAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Do: set focus to first focusable element.",
            "title": "Do: set focus to first focusable element.",
            "src": "/static/e515474fc01098d5884bb32638b72741/377f4/dialog-focus-do.png",
            "srcSet": ["/static/e515474fc01098d5884bb32638b72741/7fc1e/dialog-focus-do.png 288w", "/static/e515474fc01098d5884bb32638b72741/a5df1/dialog-focus-do.png 576w", "/static/e515474fc01098d5884bb32638b72741/377f4/dialog-focus-do.png 1088w"],
            "sizes": "(max-width: 1088px) 100vw, 1088px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </DoDont>
      <DoDont colMd={6} colLg={6} type="dont" caption="Don’t set the first focus on the dialog button if there are inputs or selection to be made in the dialog." mdxType="DoDont">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1088px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "91.91176470588235%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAACcUlEQVQ4y62Uy2tTQRTG7124t+1KcVtUxAdIcicJJgiiFPonuBBa62OlWHSpW8GV/0TjTtBSN1qyrZEkiItGKKWkNI8+kpvkJvfOzD1+c/KwDwOFeODLNzP3zm/mnEOuZSGIyBo3/gfj31GtVm3jjUbjTa1Wy0Lf9vb2MvCM8d3d3czBwUGm1Wplms0m+6HxKvatua771jDwnm1tbGwwcH9//yNeoM3NTSqXy1QqlWh7e5u2trYIz8hEGIZHpJTidUC/Di+3s7PDwHq9vtRutwlQ3/M8hbHCmIXbjJKvtTZ7PhkG3LY6nY7dn6TNaYBJiLBO3W6XpJR8kxFS/T3L/cbYFjYwEIsMRD0kZNykwmDf90eJgciGgeDbVqVSGTQlHQQBoQkSzTBOKMMQPDjkmJRJGakv9xl2rzMIPOQbAiINAOvmZL6JSf3UN+S8D6WMkHT6OFlDtH9sIOr8F4i6Hemy7AWdlKLgmKTSDHSbLQZ2u75toQ4MBJiBmMthzfrO845LQacBh7yhANRYdxnY8eq2lcvlGJjP59PFYpHgQaFQCIfK5+E/w+y6G66te+H3YjvM/vYGkr9KRPDPhvEjh3/KzMwMA+Px+IfZ2VlKpVIqEomQ4zgUdQQ5kZsUTdyh6ac1uvSC6PwTTWfnQpqcN9Jq8jHRuQX5hb81z1DDRCLBwFgstpRMJglgXwihMdciFtcxJ6Jjt+7qC/M1PbVAempe6Yk5PVAw8QiHPPRXADxjvcNvNBq1+sBpjBOAOYAKzMGDi6iIJ++JG8+r4vIiiauLUlx/qcS1nhyME1de0UXDeHB/tfcJQ3pjfwbf337N/gfuooW6u5u9bAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Don’t set the first focus on the dialog button if there are inputs or selection to be made in the dialog.",
            "title": "Don’t set the first focus on the dialog button if there are inputs or selection to be made in the dialog.",
            "src": "/static/26176b0a6cb5d4b1a9a353ef147c4de8/377f4/dialog-focus-dont.png",
            "srcSet": ["/static/26176b0a6cb5d4b1a9a353ef147c4de8/7fc1e/dialog-focus-dont.png 288w", "/static/26176b0a6cb5d4b1a9a353ef147c4de8/a5df1/dialog-focus-dont.png 576w", "/static/26176b0a6cb5d4b1a9a353ef147c4de8/377f4/dialog-focus-dont.png 1088w"],
            "sizes": "(max-width: 1088px) 100vw, 1088px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </DoDont>
    </DoDontRow>
    <h3>{`Keyboard navigation`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`ESC`}</inlineCode>{`: close the dialog`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`tab`}</inlineCode>{`: navigates the user to the different interactive elements`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`space bar`}</inlineCode>{`: triggers the selected element`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`enter`}</inlineCode>{`: triggers the selected element`}</li>
    </ul>
    <h3>{`Tab order`}</h3>
    <ol>
      <li parentName="ol">{`First interactive element in the body area.`}</li>
      <li parentName="ol">{`Proceed left to right and top to bottom through the rest of the body elements.`}</li>
      <li parentName="ol">{`Primary action`}</li>
      <li parentName="ol">{`Secondary action`}</li>
      <li parentName="ol">{`Close icon`}</li>
    </ol>
    <h3>{`ARIA`}</h3>
    <p>{`See WAI-ARIA Authoring Practices `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html"
      }}>{`Modal Dialog Example, Accessibility Features`}</a>{` section for best practices.`}</p>
    <h2>{`Related components and patterns`}</h2>
    <Row mdxType="Row">
      <Column colSm={2} colMd={2} colLg={4} mdxType="Column">
        <h4>{`Components:`}</h4>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/button/usage"
            }}>{`Buttons`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/modal/code"
            }}>{`Modal`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/notification/usage"
            }}>{`Notification`}</a></li>
        </ul>
      </Column>
      <Column colSm={2} colMd={2} colLg={4} mdxType="Column">
        <h4>{`Patterns:`}</h4>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/patterns/forms-pattern"
            }}>{`Forms`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/patterns/notification-pattern"
            }}>{`Notifications`}</a></li>
        </ul>
      </Column>
    </Row>
    <h2>{`References`}</h2>
    <ul>
      <li parentName="ul">{`Apple Human Interface Guidelines, `}<a parentName="li" {...{
          "href": "https://developer.apple.com/design/human-interface-guidelines/ios/app-architecture/modality/"
        }}>{`Modality`}</a>{` (2019)`}</li>
      <li parentName="ul">{`Apple Human Interface Guidelines, `}<a parentName="li" {...{
          "href": "https://developer.apple.com/design/human-interface-guidelines/macos/windows-and-views/dialogs/"
        }}>{`Dialogs`}</a>{` (2019)`}</li>
      <li parentName="ul">{`Therese Fessenden, `}<a parentName="li" {...{
          "href": "https://www.nngroup.com/articles/modal-nonmodal-dialog/"
        }}>{`Modal & Nonmodal Dialogs: When (& When Not) to Use Them`}</a>{` (Nielsen Norman Group, 2017)`}</li>
      <li parentName="ul">{`James Jacobs, `}<a parentName="li" {...{
          "href": "https://medium.com/pulsar/modern-enterprise-ui-design-part-2-modal-dialogs-2ccd3cc33c92"
        }}>{`Modern Enterprise UI design — Part 2: Modal dialogs`}</a>{` (2019)`}</li>
      <li parentName="ul">{`Micosoft Docs, `}<a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/win32/dlgbox/about-dialog-boxes"
        }}>{`About Dialog Boxes`}</a>{` (2019)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/standards-guidelines/wcag/"
        }}>{`Web Content Accessibility Guidelines`}</a>{` (W3C, 2018)`}</li>
    </ul>
    <h2>{`Feedback`}</h2>
    <p>{`Help us improve this pattern by providing feedback, asking questions, and leaving any other comments on `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/new?assignees=&labels=feedback&template=feedback.md"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      